module.exports = __webpack_public_path__ + "img/arrow.3038531b.svg";